import "/__w/1/s/BotFramework-WebChat/packages/component/src/SendBox/AttachmentBar/AttachmentBar.module_built.css";
const classes = {"send-box-attachment-bar--as-thumbnail":"wAcnLYa_send-box-attachment-bar--as-thumbnail","send-box-attachment-bar":"wAcnLYa_send-box-attachment-bar","send-box-attachment-bar__box":"wAcnLYa_send-box-attachment-bar__box","send-box-attachment-bar--as-list-item":"wAcnLYa_send-box-attachment-bar--as-list-item"}
export default classes

const _send_box_attachment_bar__as_thumbnail0 = classes["send-box-attachment-bar--as-thumbnail"]
export { _send_box_attachment_bar__as_thumbnail0 as "send-box-attachment-bar--as-thumbnail" }

const _send_box_attachment_bar0 = classes["send-box-attachment-bar"]
export { _send_box_attachment_bar0 as "send-box-attachment-bar" }

const _send_box_attachment_bar__box0 = classes["send-box-attachment-bar__box"]
export { _send_box_attachment_bar__box0 as "send-box-attachment-bar__box" }

const _send_box_attachment_bar__as_list_item0 = classes["send-box-attachment-bar--as-list-item"]
export { _send_box_attachment_bar__as_list_item0 as "send-box-attachment-bar--as-list-item" }
